import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from 'app/modules/core.module';
import { GroupOfPoliceService } from '@services/groupOfPolicies.service';
import { ModalGroupOfPoliciesComponent } from '@components/managements/group-of-policies/modal-group-of-policies/modal-group-of-policies.component';
import { PanelComponent } from '@components/core-template/panel/panel.component';
// import { PermissionsService } from '@services/permissions.service';

@Component({
  selector: 'app-group-of-policies',
  standalone: true,
  imports: [PanelComponent, ModalGroupOfPoliciesComponent, CoreModule,],
  providers: [GroupOfPoliceService],
  templateUrl: './group-of-policies.component.html',
  styleUrls: ['./group-of-policies.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupOfPoliciesComponent implements OnInit {

  public listGroups: any[] = []
  public listGroupsTemp: any[] = []
  public editGroup: any
  public nameGroup: any 
  public modalOptions = {
    size: 'lg',
    scrollable: true,
    animation: true,
    backdrop: true
  }
  public closeResult = ""

  // private _permissionsService = inject(PermissionsService)
  protected permissions: any
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  constructor(
    private _groupOfPolicesService: GroupOfPoliceService,
    private fb: FormBuilder,
    private modalService: NgbModal,
  ){

  }

  public years: number[] = []
  public selectedYear: number | null = null
  protected showDisabled = false

  ngOnInit(): void {
    this.buildYears()
    this.getGroupOfPolicies()
    this.getPermissions()
  }

  buildYears() {
    const currentYear = new Date().getFullYear()
    this.selectedYear = currentYear
    for (let y = currentYear - 1; y <= currentYear; y++) {
      this.years.push(y)
    }
  }

  getPermissions() {
    // this._permissionsService.get("administracion-grupos").subscribe(res => {
    //   this.permissions = res.actions
    // })
  }

  getGroupOfPolicies(){
    this._groupOfPolicesService.getAll(this.selectedYear).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => { this.listGroups = res; this.listGroupsTemp = res; this.filterGroup(); this.cdr.markForCheck() })
  }

  createType(){
    this._groupOfPolicesService.createType({}).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
     
    })
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `${reason}`;
    });
  }

  onYearChange() {
    this.getGroupOfPolicies()
  }

  filterGroup() {
    this.listGroups = this.listGroupsTemp.filter(g => {
      const matchName = (this.nameGroup || '').length === 0 || g.name.toLowerCase().includes(this.nameGroup.toLowerCase())
      const matchEnabled = this.showDisabled || g.enabled !== false
      return matchName && matchEnabled
    })
  }
}
